<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="grants-container">
  @for (grant of filteredGrants; track grant) {
    <div class="col-lg-4 col-md-6 grant-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ grant.name }}</h5>
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p><strong>Godina:</strong> {{ grant.year }}</p>
          <p><strong>Vrijedi do:</strong> {{ grant.validUntil | date: 'd.M.yyyy.' }}</p>
          <div class="description">
            <div [innerHTML]="grant.description"></div>
          </div>
          @if (documentsMap[grant.id]) {
            <div>
              <p><strong>Preuzmite projektnu dokumentaciju klikom na svaki od sljedećih poveznica:</strong></p>
              <ul>
                @for (document of documentsMap[grant.id]; track document) {
                  <li>
                    <a href="javascript:void(0)" (click)="onDocumentDownloaded(grant.id, document)">
                      {{ document.name }}
                    </a>
                    <mat-checkbox
                      [(ngModel)]="downloadedFiles[grant.id][document.link]"
                      [disabled]="true">
                      Preuzeto
                    </mat-checkbox>
                  </li>
                }
              </ul>
            </div>
          }
          <mat-checkbox
            [(ngModel)]="isAcknowledged[grant.id]"
            (change)="acknowledgeDocuments(grant.id, $event)"
            [disabled]="!areAllDocumentsDownloaded(grant.id)"
            >
            <p>Prihvaćam da sam pročitao svu relevantnu dokumentaciju</p>
          </mat-checkbox>
        </mat-card-content>
        <mat-card-actions>
          <button mat-flat-button color="primary" class="daxa"  (click)="applyForGrant(grant)" [disabled]="!isAcknowledged[grant.id]">
            Prijava
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>